module.exports = __webpack_public_path__ + "static/media/cl.dc9f3dac.svg";